<script setup lang="ts">
import { Card, CardContent } from '@/components/ui/card'
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog'
import { Eye } from 'lucide-vue-next'

import { BillingInfo } from '@/@types'
import { Order, OrdersnapShot } from '@/@types/order'
import { Button } from '@/components/ui/button'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface OrderShow extends Order {
    order_snap_shot: OrdersnapShot
}

defineProps<{ order: OrderShow; billing_info: BillingInfo }>()
</script>

<template>
    <Dialog>
        <DialogTrigger>
            <DropdownMenuItem @select.prevent>
                <Button variant="ghost" size="sm" class="text-muted-foreground w-full justify-start"> <Eye /> {{ $t('View responsible') }} </Button>
            </DropdownMenuItem>
        </DialogTrigger>
        <DialogContent class="lg:max-w-4xl">
            <Tabs>
                <div class="flex items-center justify-between overflow-x-auto">
                    <TabsList className="max-w-full">
                        <div class="bg-muted overflow-x-auto rounded-md p-1">
                            <TabsTrigger class="data-[state=active]:bg-white" value="personal-data">
                                {{ $t('Personal data') }}
                            </TabsTrigger>
                            <TabsTrigger class="data-[state=active]:bg-white" value="professional-data">
                                {{ $t('Professional Information') }}
                            </TabsTrigger>
                        </div>
                    </TabsList>
                </div>

                <Card class="mt-4 border-transparent">
                    <CardContent class="rounded-xl bg-gray-100 pt-6">
                        <TabsContent value="personal-data" class="font-inter">
                            <strong class="text-lg font-semibold">{{ $t('Personal data') }}</strong>

                            <div class="mt-4 grid gap-4 sm:grid-cols-[160px_1fr]">
                                <p>{{ $t('Full name') }}:</p>
                                <p class="font-semibold">{{ order.user.name }}</p>

                                <p>{{ $t('Email') }}:</p>
                                <p class="font-semibold">{{ order.user.email }}</p>

                                <p>Linkedin</p>
                                <p class="font-semibold">{{ order.user.billing_linkedin }}</p>
                                <p>{{ $t('Phone') }}</p>
                                <p class="font-semibold">{{ order.user.phone }}</p>
                            </div>
                        </TabsContent>
                        <TabsContent value="professional-data" class="font-inter">
                            <strong class="text-lg font-semibold">{{ $t('Professional Information') }}</strong>

                            <div class="mt-4 grid gap-4 sm:grid-cols-[160px_1fr]">
                                <p>{{ $t('Company') }}:</p>
                                <p class="font-semibold">{{ order.user.billing_empresa }}</p>
                                <p>{{ $t('Area') }}:</p>
                                <p class="font-semibold">{{ order.user.billing_area }}</p>
                                <p>{{ $t('Sector') }}:</p>
                                <p class="font-semibold">{{ order.user.billing_setor }}</p>
                                <p>{{ $t('Hierarchical level') }}:</p>
                                <p class="font-semibold">{{ order.user.billing_nivel_hierarquico }}</p>
                            </div>
                        </TabsContent>
                    </CardContent>
                </Card>
            </Tabs>
        </DialogContent>
    </Dialog>
</template>
